import React from 'react';
import { graphql } from 'gatsby';
import qs from 'querystringify';

import FormContainer from 'components/FormContainer';
import PageWrapper from 'components/PageWrapper';
import StateWrapper from 'components/ClientOrderRequestForm/StateWrapper';

import Hero from 'storyblok/components/Hero';

const SelectedPartnerContext = React.createContext();

const GetStarted = ({ data, location: { search } }) => {
	return (
		<SelectedPartnerContext.Provider value={qs.parse(search).restaurant}>
			<PageWrapper
				title="Get Started with Portland Oregon Catering"
				description={`Begin your catering experience with ${data.site.siteMetadata.title} in Portland, Oregon. Submit your event details and let us create a custom menu and seamless food experience.`}
				postContent={
					process.env.GATSBY_MAINTENANCE_MODE === 'true' ? (
						<>
							<Hero
								blok={{
									backgroundImage:
										data.headerImage.childImageSharp.fluid,
									headline: 'Under Maintenance',
									height: 'medium',
									subHeadline: `We're updating our form and will be back shortly.`,
								}}
							/>
						</>
					) : (
						<>
							<Hero
								blok={{
									backgroundImage:
										data.headerImage.childImageSharp.fluid,
									headline: 'Get Started',
									height: 'short',
									subHeadline: `Fill out this form and we'll get in touch shortly!`,
								}}
							/>
							<FormContainer>
								<StateWrapper />
							</FormContainer>
						</>
					)
				}
				displayNewsletterSignup={false}
			/>
		</SelectedPartnerContext.Provider>
	);
};

export const query = graphql`
	query GetHeaderImageForGetStarted {
		headerImage: file(relativePath: { eq: "get-started-hero.jpg" }) {
			childImageSharp {
				fluid(maxWidth: 1500) {
					...GatsbyImageSharpFluid_tracedSVG
				}
				fixed(height: 630, width: 1200) {
					src
				}
			}
		}
		site {
			siteMetadata {
				title
				url
			}
		}
	}
`;

export default GetStarted;
export { SelectedPartnerContext };
